import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Guid } from '@fitscovery/common/types';
import { environment } from 'apps/partner-web/src/environments/environment';
import { MembershipRequest, MembershipService } from './interface';
import { Membership } from './models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class ApiMembershipService implements MembershipService {
	constructor(
		private http: HttpClient,
	) {
	}

  hasAccessToWorkoutOrProgram(partnerId: Guid, userId: Guid, selectedId: Guid) {
    const baseUrl = `${environment.azureFunctionsApi.memberships}`;
    const endpoint = `${baseUrl}/memberships/partners/${partnerId}/users/${userId}/has-access/workout-or-program/${selectedId}`
    return this.http.post(endpoint, { partnerId, userId, selectedId });
  }

	applyForMembership(request: MembershipRequest): Observable<Membership> {
		return (this.http.post(`${environment.azureFunctionsApi.memberships}/memberships/apply`, request) as any)
			.pipe(
				map((response: GetMembershipResponse) => {
					return response.data;
				})
			);
	}

	applyForMembershipSubscription(request: MembershipRequest): Observable<Membership> {
		const dataRequest = {
			email: request.email,
			partnerMembershipSubscriptionId: request.subscriptionId,
			partnerId: request.partnerId,
			userId: request.userId
		};

		return (this.http.post(`${environment.azureFunctionsApi.memberships}/memberships/apply-subscription`, dataRequest) as any)
			.pipe(
				map((response: GetMembershipResponse) => {
					return response.data;
				})
			);
	}

	getMembershipsByMemberAndPartnerId(memberId: Guid, partnerId: Guid): Observable<Membership[]> {
		return (this.http.get(`${environment.azureFunctionsApi.memberships}/partners/${partnerId}/members/${memberId}/subscriptions`) as any)
			.pipe(
				map((memberships: Membership[]) => {
					return memberships;
				})
			);
	}
}

class BaseResponse {
	errors: string[];
	succeeded: boolean;
}

class Request {
	subdomain: string;
}

class GetMembershipResponse extends BaseResponse {
	request: Request;
	data: any;
}
